import styled from 'styled-components'

import { type ExtendedShopInfo } from '~/features/ticket/types/ticket'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

type Props = {
  data: Pick<ExtendedShopInfo, 'refund_rule'>
}

function RefundRule({ data }: Props) {
  const { refund_rule } = data

  return (
    <Wrapper>
      <TagBox>
        <Tag $size={'md'} $variant={'gray'}>
          취소 및 환불 규정
        </Tag>
        <Desc>{refund_rule}</Desc>
      </TagBox>
      <Caution>
        환불 요청 기간에 따라 위약금이 발생할 수 있습니다. 환불 요청 시 결제
        수단 별로 수수료가 발생될 수 있습니다. (위약금 / 결제 수단 수수료 별도)
        예시{')'} 이벤트 시작 7일 전 가상계좌 결제 건 환불 요청 시 -{'>'} 위약금
        10% + 가상계좌 이체 300원 수수료 발생 자세한 환불 금액 확인은 고객센터를
        통해 문의 부탁드립니다. 각 크리에이터 별로 특수 환불 정책에 따라 환불이
        불가할 수 있습니다.
      </Caution>
    </Wrapper>
  )
}

export default RefundRule

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const TagBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Desc = styled.p`
  padding-left: 20px;

  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  white-space: pre-line;
`

const Caution = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 100%;
  height: 105px;
  padding: 20px;

  line-height: 140%;

  background-color: #f0f0f0;
  border-radius: 12px;

  @media ${theme.device.medium} {
    height: auto;
  }
`
